// Function to check if an asterisk is present at the end of the label
export const isAsteriskPresent = (input: string): boolean => {
    return input.endsWith('*');
};

// Function to get the main label without the asterisk
export const mainLabel = (input: string): string => {
    return isAsteriskPresent(input) ? input.slice(0, -1).trim() : input;
};
